const routes = {
    home: {path: "/"},
    admin: {path: "/admin"},
    adminUsers: {path: "/admin/users"},
    adminCourses: {path: "/admin/courses"},
    adminSubscriptions: {path: "/admin/subscriptions"},
    adminFeaturedAddCourse: {path: "/admin/featured/courses/add"},
    adminFeaturedAddContent: {path: "/admin/featured/content/add"},
    adminFeaturedAddSchool: {path: "/admin/featured/schools/add"},
    adminFeatured: {path: "/admin/featured"},
    adminProfile: {path: "/admin/profile/:id"},
    signup: {path: "/signup"},
    signin: {path: "/signin"},
    profile: {path: "/profile"},
    profileById: {path: "/profile/:id"},
    profileEdit: {path: "/profile/edit"},
    courses: {path: "/courses"},
    selfStudycourses: {path: "/self-study-courses"},
    selfStudycourse: {path: "/self-study-courses/:id"},
    selfStudycourseLecture: {path: "/self-study-courses/:id/Lecture"},
    course: {path: "/courses/:id"},
    coursesAdd: {path: "/courses/add"},
    coursesAddWithId: {path: "/courses/add/:id"},
    coursesEdit: {path: "/courses/edit/:id"},
    coursesRequested: {path: "/courses/requested"},
    coursesRequestedEdit: {path: "/courses/requested/edit/:id"},
    coursesSearch: {path: "/courses/search"},
    programs: {path: "/programs"},
    program: {path: "/programs/:id"},
    meetings: {path: "/meetings"},
    children: {path: "/children"},
    reset: {path: "/reset"},
    quizzes: {path: "/quizzes"},
    library: {path: "/library"},
    invitations: {path: "/invitations"},
    lectures: {path: "/lectures"},
    lecture: {path: "/lectures/:id"},
    lectureDigest: {path: "/lectures/:id/digest"},
    meetingDigest: {path: "/meetings/:id/digest"},
    lectureSelfStudy: {path: "/lectures/:id/self-study"},
    lectureReview: {path: "/lectures/:id/review"},
    lectureAssignment: {path: "/lectures/:id/assignment/:assignmentId"},
    wallet: {path: "/wallet"},
    balance: {path: "/wallet/balance"},
    walletSubscriptions: {path: "/wallet/subscriptions"},
    walletPacks: {path: "/wallet/packs"},
    walletHistory: {path: "/wallet/history"},
    walletVouchers: {path: "/wallet/vouchers"},
    weightageCategory: {path: "/weightage-categories"},
    gradingSchema: {path: "/gradingSchema"},
    notifications: {path: "/notifications"},
    content: {path: "/content"},
    contentCreate: {path: "/content/create"},
    contentEdit: {path: "/content/:id/edit"},
    contentForPlayList: {path: "/content/:contentId/playlist"},
    contentForPublisherShow: {path: "/content/:contentId/:innerContentId"},

    contentShow: {path: "/content/:contentId"},
    market: {path: "/market"},
    browse: {path: "/browse"},
    shared: {path: "/shared"},
    sharedCourse: {path: "/shared/course/:id"},
    schools: {path: "/schools"},
    schoolLectures: {path: "/schools/lectures"},
    school: {path: "/schools/:id"},
    schoolEdit: {path: "/schools/edit/:id/"},
    schoolCreate: {path: "/schools/create"},
    schoolCourseCreate: {path: "/schools/:schoolId/courses/add/:id"},
    schoolCourseEdit: {path: "/schools/:schoolId/courses/edit/:id"},
    schoolList: {path: "/schools/list"},
    schoolProgramCreate: {path: "/schools/:schoolId/programs/add"},
    schoolProgramEdit: {path: "/schools/:schoolId/programs/edit/:id"},
    schoolProgramClone: {path: "/schools/:schoolId/programs/clone/:id"},
    teachers: {path: "/teachers"},
    teachersCreate: {path: "/teachers/create"},
    teachersInvite: {path: "/teachers/invite"},
    students: {path: "/students"},
    terms: {path: "/terms"},
    privacy: {path: "/privacy"},
    paymentTerms: {path: "/payment-terms"},
    callback: {path: "/callback"},
    chats: {path: "/chat"},
    chat: {path: "/chat/:id"},
    customPage: {path: "/:customPath"},
    myWork: {path: "/work"},
    ixl: {path: "/ixl"},
    assignments: {path: "/assignments"},
    assessments: {path: "/assessments"},
    grades: {path: "/grades"}
};

const getRoute = (route, params = {}, extraPath = "") => {
    const routePath = typeof route === "object" ? route.path : route;
    const basePath = Object.keys(params).reduce((acc, key) => acc.replace(`:${key}`, params[key]), routePath);
    return basePath + extraPath;
};

export {getRoute};
export default routes;
